export const userTranslationFunctions = {
    methods: {
        getClassificatorOrClassificatorRowTitle(classificatorTitle) {
            classificatorTitle = JSON.parse(classificatorTitle);
            if (classificatorTitle.et) {
                return classificatorTitle.et;
            } else {
                return classificatorTitle.en;
            }
        }
    }
};
